export const tryParseDateTime = (dateTimeString: string): { isSuccess: boolean; dateTime?: Date } => {
    try {
        const dateTime = new Date(dateTimeString); // Parse the datetime string

        if (!dateTime || isNaN(dateTime.getTime())) {
            return { isSuccess: false };
        }

        return { isSuccess: true, dateTime: dateTime };
    } catch (error) {
        console.error(error);
        return { isSuccess: false };
    }
};

export const formatTimeDifference = (differenceInMilliseconds: number): string => {
    const totalMinutes = Math.ceil(differenceInMilliseconds / (1000 * 60)); // Convert to total minutes
    const hours = Math.floor(totalMinutes / 60); // Extract hours
    const minutes = totalMinutes % 60; // Get remaining minutes

    if (hours > 0 && minutes > 0) {
        return `${hours} hour(s) ${minutes} minute(s)`;
    } else if (hours > 0) {
        return `${hours} hour(s)`;
    } else {
        return `${minutes} minute(s)`;
    }
};

export const validateTimeSlotValue = (
    datetimeString: string,
    currentTime: Date,
    expirationTimeInMinutes: number
): { valid: boolean; message?: string } => {
    const parseResult = tryParseDateTime(datetimeString); // Parse the datetime string
    if (!parseResult.isSuccess) {
        return { valid: true }; // do not validate timslot value in case invalid format
    }

    const slotTime = parseResult.dateTime!; // Slot time

    const differenceInMilliseconds = slotTime.getTime() - currentTime.getTime(); // Time difference in milliseconds
    const expirationInMilliseconds = expirationTimeInMinutes * 60 * 1000; // Timespan in milliseconds

    if (differenceInMilliseconds < 0) {
        // If the slot time is in the past
        return { valid: false, message: `Time is already expired` };
    } else if (expirationInMilliseconds !== 0 && differenceInMilliseconds <= expirationInMilliseconds) {
        // If the difference is within the expiration time
        const timeDifference = formatTimeDifference(differenceInMilliseconds);
        return { valid: false, message: `Slot time will expire in ${timeDifference}` };
    }

    // If the input datetime is valid and not about to expire
    return { valid: true };
};

export const minutesToMs = (m: number) => m * 60_000;
